import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function HeroSection() {
  const featuredVideos = videos.slice(0, 4);

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20and%20amber%20flowing%20light%20streaks%20on%20dark%20background%2C%20cinematic%20atmosphere%2C%20elegant%20geometric%20patterns%2C%20modern%20digital%20entertainment%20vibe%2C%20luxurious%20texture%2C%20soft%20gradient%20from%20warm%20orange%20to%20deep%20brown%2C%20minimal%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="福利视频在线背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="container-custom relative z-10 w-full py-20 md:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight">
              福利视频在线
            </h1>
            <p className="text-lg md:text-xl text-background-200 mb-3">
              免费观看 · 高清画质 · 即点即看
            </p>
            <p className="text-sm md:text-base text-background-300/80 max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              汇聚热门影视、综艺、短视频资源，无需下载即可流畅播放。随时随地畅享极致视觉体验，支持高清画质与多设备兼容，完全免费。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/dianshiju"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观看
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3 border border-background-300/50 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap text-center"
              >
                了解更多
              </Link>
            </div>
            <div className="flex flex-wrap items-center gap-6 justify-center lg:justify-start mt-8 text-xs text-background-300">
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400"></i>
                <span>完全免费</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400"></i>
                <span>无需注册</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400"></i>
                <span>高清画质</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400"></i>
                <span>多端兼容</span>
              </div>
            </div>
          </div>

          <div className="hidden lg:grid grid-cols-2 gap-3">
            {featuredVideos.map((video) => (
              <Link
                key={video.id}
                to={`/article/${video.slug}`}
                className="group relative rounded-lg overflow-hidden border border-background-50/10 hover:border-primary-400/50 transition-all duration-300"
              >
                <img
                  src={video.coverImage}
                  alt={video.title}
                  className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2">
                  <p className="text-background-50 text-xs font-medium line-clamp-2">
                    {video.title}
                  </p>
                  <div className="flex items-center gap-2 mt-1 text-background-300 text-xs">
                    <span>{video.duration}</span>
                    <span className="text-primary-400">{video.rating.toFixed(1)}分</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}